import{_ as r}from"./helpers-C8k3UfPS.js";import{useCallback as t}from"react";function e(e,n){return t((function(t){e.current=t,"function"==typeof n?n(t):"object"===r(n)&&null!==n&&(n.current=t)}),[e,n])}export{e as default};
